// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edume-chevron[data-v-5b1c9ed8]{display:flex;align-items:center;justify-content:center;height:20px;width:20px}.edume-down[data-v-5b1c9ed8]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
